import * as yup from 'yup';

export const beneficiary_schema = {
  type: '',
  bank: '',
  beneficiary: '',
  non_ksa_beneficiary: '',
  iban: '',
  non_ksa_iban: '',
  branch: '',
  currency: '',
  swift_code: '',
  non_ksa_bank: '',
  non_ksa_branch: '',
  registered_address: '',
  aba_routing: '',
};

const iban_regex = process.env.REACT_APP_ENVIRONMENT !== 'UAT' ? /^SA\d{22}$/ : /^SA[A-Z0-9]{22}$/

export const beneficiary_validation_schema = yup.object().shape({
  type: yup.object().required('beneficiary_type_required'),
  // beneficiary: yup.string().when(['type'], {
  //   is: (type) => Number(type?.id) === 1574,
  //   then: (schema) => schema.required('beneficiary_required'),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  beneficiary: yup.string(),

  bank: yup.object().when(['type'], {
    is: (type) => Number(type?.id) === 1574,
    then: (schema) => schema.required('bank_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  branch: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1574,
    then: (schema) => schema.required('branch_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  iban: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1574,
    then: (schema) =>
      schema
        .required('iban_required')
        .matches(iban_regex, 'iban_must_be_22_digits'),
    // .matches(/^SA[A-Z0-9]{22}$/, 'iban_must_be_22_digits'),
    otherwise: (schema) => schema.notRequired(),
  }),

  non_ksa_beneficiary: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1575,
    then: (schema) => schema.required('beneficiary_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  non_ksa_bank: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1575,
    then: (schema) => schema.required('bank_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  non_ksa_branch: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1575,
    then: (schema) => schema.required('branch_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  non_ksa_iban: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1575,
    then: (schema) =>
      schema
        .required('iban_required')
        .matches(
          /^(?!SA)(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{15,34}$/,
          // /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9]{15,34}$/,
          'iban_must_be_32_digits'
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  registered_address: yup.string().when(['type'], {
    is: (type) => Number(type?.id) === 1575,
    then: (schema) => schema.required('registered_address_required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  // aba_routing: yup.string().when(['type'], {
  //   is: (type) => Number(type?.id) === 1575,
  //   then: (schema) => schema.required('aba_routing_required'),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  aba_routing: yup.string(),

  // currency: yup.object().required("currency_required"),
  swift_code: yup.string(),
});
